
export const getTotalTeamStats = (assignments: any[]) => {
  // CRITICAL FIX: Use strict database role_type classification - no normalization
  const roleTypeCounts = {
    totalDirectors: 0,
    totalManagers: 0,
    totalTeamLeads: 0,
    totalTeamMembers: 0,
    totalTeamSize: 0
  };

  // Use a Set to track unique resources to avoid double counting
  const uniqueResources = new Set();
  const roleTypeMapping = new Map();

  assignments.forEach(assignment => {
    const resourceKey = `${assignment.resource_id}-${assignment.name}`;
    
    // Only count each unique resource once
    if (!uniqueResources.has(resourceKey)) {
      uniqueResources.add(resourceKey);
      
      // CRITICAL FIX: Use EXACT database role_type - no normalization or inference
      const exactRoleType = assignment.role_type;
      
      roleTypeMapping.set(resourceKey, exactRoleType);
    }
  });

  // Count by EXACT role_type values from database
  roleTypeMapping.forEach((roleType) => {
    // Use strict equality - no normalization
    if (roleType === 'project-director') {
      roleTypeCounts.totalDirectors++;
    } else if (roleType === 'project-manager') {
      roleTypeCounts.totalManagers++;
    } else if (roleType === 'team-lead') {
      roleTypeCounts.totalTeamLeads++;
    } else if (roleType === 'team-member') {
      roleTypeCounts.totalTeamMembers++;
    }
    // Note: Any other role_type values are not counted, maintaining strict classification
  });

  roleTypeCounts.totalTeamSize = uniqueResources.size;

  console.log('TEAM STATS CALCULATION WITH STRICT ROLE_TYPE:', {
    totalAssignments: assignments.length,
    uniqueResources: uniqueResources.size,
    roleCounts: roleTypeCounts,
    exactRoleTypeBreakdown: Array.from(roleTypeMapping.entries())
  });

  return roleTypeCounts;
};
